import { createApiClient, createQuery } from "@/api/utils";
import { LineageMetric, Metric } from "./Finance.model";
import { AccountLabel, PeriodKind } from "../Labeling/Account.model";
import parseLineageMetric from "./parseLineageMetric";

export const getMetrics = createQuery<
    Metric[],
    { labels: AccountLabel[]; periodKind: PeriodKind }
>(async ({ api, router, params }) => {
    const response = await api.get(
        `/finance/companies/${router.params.companyId}/metrics?period_kind=${params.periodKind}&value_kind=plain${params.labels.reduce(
            (acc, curr) => {
                return `${acc}&label=${curr}`;
            },
            "",
        )}`,
    );

    return response.data;
});

export const getMetricsV2 = createQuery<Metric[], { metricQuery: string }>(
    async ({ router, session }) => {
        const metricQuery = router.search["metric-query"] as string;
        if (!metricQuery) {
            return undefined;
        }
        const response = await createApiClient({
            token: session.token.data || undefined,
        }).get(
            `https://finance.humcapital.info/api/beta/companies/${router.params.companyId}/metric-query?value_kind=lineage&m=${metricQuery}`,
        );

        return response.data;
    },
);

export const getLineageMetrics = createQuery<
    LineageMetric[],
    { labels: AccountLabel[] }
>(async ({ api, params, router }) => {
    const response = await api.get(
        `/finance/companies/${router.params.companyId}/metrics?period_kind=monthly&value_kind=lineage${params.labels.reduce(
            (acc, curr) => {
                return `${acc}&label=${curr}`;
            },
            "",
        )}`,
    );

    console.log(response.data);

    return (Array.isArray(response.data) ? response.data : []).map(
        parseLineageMetric,
    );
});

export const getAccount = createQuery<
    { id: string; name: string; label: AccountLabel },
    { accountId: string }
>(async ({ api, params }) => {
    const response = await api.get(`/finance/accounts/${params.accountId}`);

    return response.data;
});

export const getAccounts = createQuery<
    Record<string, { id: string; name: string; label: string }>
>(async ({ api, router }) => {
    const response = await api.get(
        `/finance/accounts?limit=1000&company_id=${router.params.companyId}`,
    );

    return (
        response.data?.reduce(
            (acc, curr) => {
                acc[curr.id] = curr;
                return acc;
            },
            {} as Record<string, { id: string; name: string; label: string }>,
        ) || {}
    );
});
